const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`,
    color: `black`,
    ':hover': {
      border: `1px solid #black`,
      background: `#fbfbfb`
    }
  },
  activeRow: {
    border: `1px solid #666`,
    background: `#fbfbfb`
  },
  header: {
    borderBottom: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/CommunityTable/style/ColorBlind/list.js